import React from "react";
import { Link } from "react-router-dom";
import { dispatchCustomEvent } from "../helpers/Utilities";

/**
 * MiniUpdates
 *
 * @param   {Object}  props  Includes property for gamedata used to generate bug reports
 *
 * @return  {JSX}         Returns a div that includes update information shown in the settings panel
 */
export default function MiniUpdates(props) {
  return (
    <div>
      <h4>Updates</h4>
      <div className="x-small-text">
        <p>
          <strong>Version: </strong>4.6.1
          <span className="padding-horizontal-sm">|</span>
          <strong>Released: </strong>6.1.2023
          <span className="padding-horizontal-sm">|</span>
          <strong>Updated: </strong>6.26.2025
          <br />
        </p>
        <ul>
          <li>Fixed all patterns that were erroneously marked as having unused letters.</li>
          <li>New patterns submitted up to 6/26/2025 have been added.</li>
          <li>Cleaned up the settings panel so settings that aren't changed often appear toward the bottom.</li>
          <li>Grouped settings more appropriately.</li>
          <li>Hid some settings if they are not relevant / the supporting settings are not on. For example: chatty caller doesn't need to be displayed if not using audible calling.</li>
          <li>When using manual mode with audible chimes and the countdown displayed, the chime will play at the end of the countdown so it serves as a reminder to call the next number.</li>
        </ul>
        <p>
          See more updates in the{" "}
          <Link
            to="/releases"
            onClick={() => {
              dispatchCustomEvent("menu-open", true);
            }}>
            Release Notes
          </Link>
        </p>
        <p>
          <strong>Need to report a bug?</strong> Please use the{" "}
          <Link
            to="/contact"
            onClick={() => {
              dispatchCustomEvent("menu-open", true);
            }}>
            contact page
          </Link>
          !
        </p>
      </div>
    </div>
  );
}
